import { render, staticRenderFns } from "./CreateMerchantModal.vue?vue&type=template&id=80f40fc8&scoped=true&"
import script from "./CreateMerchantModal.vue?vue&type=script&lang=js&"
export * from "./CreateMerchantModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateMerchantModal.vue?vue&type=style&index=0&id=80f40fc8&scoped=true&lang=css&"
import style1 from "./CreateMerchantModal.vue?vue&type=style&index=1&id=80f40fc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f40fc8",
  null
  
)

export default component.exports